import * as React from 'react';
import { connect } from 'react-redux';
import './TimeoutMessage.scss';

export interface IStateProps {
  showWarning?: boolean;
}

class TimeoutMessage extends React.Component<IStateProps, {}> {
  public render() {
    if (!this.props.showWarning) {
      return null;
    }

    return (
      <div className="timeout-message">
        <div className="vert-align">
          <div className="container errorbox">
            <div className="errorcontent">
              <i className="erroricon ion-android-alert" />
              <span className="errortext">
                <span className="errorheader">Timeout</span>
                <br />
                <span>
                  Det er fått for lang tid uten at det ble gjort noe.<br />
                  Du er derfor logget ut og må starte på nytt. <br />
                </span>
              </span>
              <div className="clearfix" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect<IStateProps, {}, {}>(state => ({
  showWarning: state.timeout.showWarning
}))(TimeoutMessage);



// WEBPACK FOOTER //
// ./src/layout-components/TimeoutMessage.tsx